/** Returns the property key for the "was called" flag for the given method property key */
const wasCalledKey = (propertyKey: string) => `__wasCalled__${propertyKey}__`;

/**
 * Sets the "was called" flag for the given property key on the given object, indicating that the
 * method specified by the property key was called.
 */
export const setWasCalled = (o: any, propertyKey: string) =>
  Object.defineProperty(o, wasCalledKey(propertyKey), { value: true });

/**
 * Returns true if the method specified by the given property key on the given object has been
 * called.
 */
export const wasCalled = (o: any, propertyKey: string): boolean => !!o[wasCalledKey(propertyKey)];
